<template>
  <div class="YMCfont">
    <div class="title ft">
      <!-- {{ title }} -->
      {{ $t("langcfg.txtMcTitle") }}
    </div>
    <div id="body">
      <div class="bodyAg">
        <!-- <div class="bodyAg-a">AGE</div> -->
        <div class="bodyAg-a">{{ $t("langcfg.txtAGE") }}</div>
        <!-- <span class="clear"></span> -->
      </div>
      <div class="bodyBor" id="McMonnies">
        <div
          class="bodyBorder"
          v-for="it in age"
          :class="{ addBodyBorColor: it.id === ageId }"
          @click="ageFun(it.id)"
        >
          <!-- {{ it.name }} -->
          {{ $t(`langcfg.${it.name}`) }}
        </div>
      </div>
      <div class="bodyAg">
        <!-- <div class="bodyAg-a">AGE</div> -->
        <div class="bodyAg-b">
          <!-- Gender -->
          {{ $t("langcfg.txtGender") }}
        </div>
        <!-- <span class="clear"></span> -->
      </div>
      <div class="bodyBor" id="McMonnies">
        <div
          class="bodyBorder"
          v-for="it in sex"
          :class="{ addBodyBorColor: it.id === sexId }"
          @click="sexFun(it.id)"
        >
          <!-- {{ it.name }} -->
          {{ $t(`langcfg.${it.name}`) }}
        </div>
      </div>
      <div v-for="it in McInitData">
        <div class="bodyTitle">
          <!-- {{ it.title }} -->
          {{ $t(`langcfg.${it.title}`) }}
        </div>
        <!--        -->
        <div class="bodyBor">
          <div
            :class="{
              bodyBorder: !its.isCheckType,
              addBodyBorColor: its.check === 1,
              addNoSelect: its.isCheckType === '1'
            }"
            v-for="its in it.McMonnies"
            @click="McMonniesFun(it, its)"
          >
            <!-- {{ its.name }} -->
            {{ $t(`langcfg.${its.name}`) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";

export default {
  name: "McMonnies",
  props: ["propsChild"],
  data() {
    return {
      title: " McMonnies Dry Eye Questionnaire",
      McInitData: [
        {
          // 'title': '1.Have you ever had drops prescribed or other treatment for dry eyes?',
          title: "txtMCquesiotnTitleA",
          id: 1,
          McMonnies: [
            {
              check: "0",
              id: "0",
              // 'name': 'Yes',
              name: "txtYes",
              val: "6"
            },
            {
              check: "0",
              id: "1",
              // 'name': 'No',
              name: "txtNo",
              val: "0"
            },
            {
              check: "0",
              id: "2",
              // 'name': 'Uncertain',
              name: "txtUncertain",
              val: "0"
            }
          ]
        },
        {
          // 'title': '2 .Do you experience any of the following (if Yes, refer to question #3)',
          title: "txtMCquesiotnTitleB",
          id: 2,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Soreness ',
              name: "txtSoreness",
              val: "0",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'Scratchiness ',
              name: "txtScratchiness",
              val: "0",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'Dryness ',
              name: "txtDryness",
              val: "0",
              id: "2"
            },
            {
              check: "0",
              // 'name': 'Grittiness ',
              name: "txtGrittiness",
              val: "0",
              id: "3"
            },
            {
              check: "0",
              // 'name': 'Burning ',
              name: "txtBurning",
              val: "0",
              id: "4"
            }
          ]
        },
        {
          // 'title': '3.How often do your eyes have these symptoms?',
          title: "txtMCquesiotnTitleC",
          id: 3,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Never ',
              name: "txtNever",
              val: "0",
              id: "0",
              isCheckType: "1"
            },
            {
              check: "0",
              // 'name': 'Sometimes ',
              name: "txtSometimes",
              val: "1",
              id: "1",
              isCheckType: "1"
            },
            {
              check: "0",
              // 'name': 'Often ',
              name: "txtOften",
              val: "4",
              id: "2",
              isCheckType: "1"
            },
            {
              check: "0",
              // 'name': 'Constantly ',
              name: "txtConstantly",
              val: "8",
              id: "3",
              isCheckType: "1"
            }
          ]
        },
        {
          // 'title': '4 .Do you regard your eyes as being especially sensitive to cigarette smoke, smog, air conditioning, or heating?',
          title: "txtMCquesiotnTitleD",
          id: 4,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Yes ',
              name: "txtYes",
              val: "4",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'No ',
              name: "txtNo",
              val: "0",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'Sometimes ',
              name: "txtSometimes",
              val: "2",
              id: "2"
            }
          ]
        },
        {
          // 'title': '5 .Do your eyes easily become red and irritated when swimming in chlorinated fresh water?',
          title: "txtMCquesiotnTitleE",
          id: 5,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Not applicable ',
              name: "txtNotapplicable",
              val: "0",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'Yes ',
              name: "txtYes",
              val: "2",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'No ',
              name: "txtNo",
              val: "0",
              id: "2"
            },
            {
              check: "0",
              // 'name': 'Sometimes ',
              name: "txtSometimes",
              val: "1",
              id: "3"
            }
          ]
        },
        {
          // 'title': '6 .Are your eyes dry and irritated the day after drinking alcohol?',
          title: "txtMCquesiotnTitleF",
          id: 6,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Not applicable ',
              name: "txtNotapplicable",
              val: "0",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'Yes ',
              name: "txtYes",
              val: "4",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'No ',
              name: "txtNo",
              val: "0",
              id: "2"
            },
            {
              check: "0",
              // 'name': 'Sometimes ',
              name: "txtSometimes",
              val: "2",
              id: "3"
            }
          ]
        },
        {
          // 'title': '7. Do you take:',
          title: "txtMCquesiotnTitleG",
          id: 7,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Antihistamine eye drops ',
              name: "txtAntihistamineeyedrops",
              val: "2",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'Diuretics (fluid tablets) ',
              name: "txtDiureticsfluidtablets",
              val: "2",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'Sleeping tablets ',
              name: "txtSleepingtablets",
              val: "2",
              id: "2"
            },
            {
              check: "0",
              // 'name': 'Tranquilizers ',
              name: "txtTranquilizers",
              val: "2",
              id: "3"
            },
            {
              check: "0",
              // 'name': 'Oral contraceptives ',
              name: "txtOralcontraceptives",
              val: "2",
              id: "4"
            },
            {
              check: "0",
              // 'name': 'Medication for duodenal ulcer ',
              name: "txtMedicationforduodenalulcer",
              val: "1",
              id: "5"
            },
            {
              check: "0",
              // 'name': 'Medication for digestive problems ',
              name: "txtMedicationfordigestiveproblems",
              val: "1",
              id: "6"
            },
            {
              check: "0",
              // 'name': 'Medication for high blood pressure ',
              name: "txtMedicationforhighbloodpressure",
              val: "1",
              id: "7"
            },
            {
              check: "0",
              // 'name': 'Other ',
              name: "txtOther",
              val: "1",
              id: "8"
            }
          ]
        },
        {
          // 'title': '8. Do you suffer from arthritis?',
          title: "txtMCquesiotnTitleH",
          id: 8,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Yes ',
              name: "txtYes",
              val: "2",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'No ',
              name: "txtNo",
              val: "0",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'Uncertain ',
              name: "txtUncertain",
              val: "0",
              id: "2"
            }
          ]
        },
        {
          // 'title': '9. Do you experience dryness of the nose, mouth, throat, chest, or vagina?',
          title: "txtMCquesiotnTitleI",
          id: 9,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Never ',
              name: "txtNeverforNine",
              val: "0",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'Sometimes ',
              name: "txtSometimesforNine",
              val: "1",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'Often ',
              name: "txtOften",
              val: "2",
              id: "2"
            },
            {
              check: "0",
              // 'name': 'Constantly',
              name: "txtConstantly",
              val: "4",
              id: "3"
            }
          ]
        },
        {
          // 'title': '10. Do you suffer from thyroid abnormality?',
          title: "txtMCquesiotnTitleJ",
          id: 10,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Yes ',
              name: "txtYes",
              val: "2",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'No ',
              name: "txtNo",
              val: "0",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'Uncertain ',
              name: "txtUncertain",
              val: "0",
              id: "2"
            }
          ]
        },
        {
          // 'title': '11. Are you known to sleep with your eyes partly open?',
          title: "txtMCquesiotnTitleK",
          id: 11,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Yes ',
              name: "txtYes",
              val: "2",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'No ',
              name: "txtNo",
              val: "0",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'Uncertain ',
              name: "txtUncertain",
              val: "0",
              id: "2"
            }
          ]
        },
        {
          // 'title': '12. Do you have eye irritation when you wake up from sleeping?',
          title: "txtMCquesiotnTitleL",
          id: 12,
          McMonnies: [
            {
              check: "0",
              // 'name': 'Yes ',
              name: "txtYes",
              val: "2",
              id: "0"
            },
            {
              check: "0",
              // 'name': 'No ',
              name: "txtNo",
              val: "0",
              id: "1"
            },
            {
              check: "0",
              // 'name': 'Uncertain ',
              name: "txtUncertain",
              val: "1",
              id: "2"
            }
          ]
        }
      ],

      age: [
        {
          // 'name': 'Under 25 Years',
          name: "txtUnderAge",
          id: "0"
        },
        {
          // 'name': ' 25 - 45 Years',
          name: "txtBetweenAge",
          id: "1"
        },
        {
          // 'name': 'Over 45 Years',
          name: "txtOverAge",
          id: "2"
        }
      ],
      sex: [
        {
          // 'name': 'Male',
          name: "txtMale",
          id: "0"
        },
        {
          // 'name': 'Female',
          name: "txtFemale",
          id: "1"
        },
        {
          // 'name': 'Female',
          name: "txtSexOther",
          id: "2"
        },
        {
          // 'name': 'Female',
          name: "txtSexUnknown",
          id: "3"
        }
      ],
      McMonniesArr: [],
      noCheckAll: [],
      agToal: null,
      ageId: undefined,
      sexId: undefined,
      isGet3Type: false
    };
  },
  methods: {
    ageFun(id) {
      this.ageId = id;
      this.agFunction();
    },
    sexFun(id) {
      this.sexId = id;
      this.agFunction();
    },
    McMonniesFun(it, its) {
      let isCheckType2 = false;
      let isCheckType = false;
      if (it.id === 2) {
        // 这是判断点击与第三组联共
        for (let i = 0; i < this.McInitData[it.id].McMonnies.length; i++) {
          this.McInitData[it.id].McMonnies[i].isCheckType = false;
        }
        if (this.McInitData[it.id - 1].McMonnies[Number(its.id)].check === 1) {
          this.McInitData[it.id - 1].McMonnies[Number(its.id)].check = "0";
        } else {
          this.McInitData[it.id - 1].McMonnies[Number(its.id)].check = 1;
          this.isGet3Type = true;
        }

        // 这是判断点击还原
        for (let i = 0; i < this.McInitData[it.id - 1].McMonnies.length; i++) {
          if (this.McInitData[it.id - 1].McMonnies[i].check === 1) {
            isCheckType2 = true;
          }
        }
        if (!isCheckType2) {
          for (let i = 0; i < this.McInitData[it.id].McMonnies.length; i++) {
            this.McInitData[it.id].McMonnies[i].isCheckType = "1";
            this.McInitData[it.id].McMonnies[i].check = "0";
          }
          this.isGet3Type = false;
        }
      } else if (it.id === 3) {
        for (let i = 0; i < this.McInitData[it.id - 2].McMonnies.length; i++) {
          if (this.McInitData[it.id - 2].McMonnies[i].check === 1) {
            isCheckType = true;
          }
        }
        if (isCheckType) {
          for (let i = 0; i < this.McInitData[it.id - 1].McMonnies.length; i++) {
            this.McInitData[it.id - 1].McMonnies[i].check = "0";
          }
          this.McInitData[it.id - 1].McMonnies[Number(its.id)].check = 1;
        }
      } else if (it.id === 7) {
        if (this.McInitData[it.id - 1].McMonnies[Number(its.id)].check === 1) {
          this.McInitData[it.id - 1].McMonnies[Number(its.id)].check = "0";
        } else {
          this.McInitData[it.id - 1].McMonnies[Number(its.id)].check = 1;
        }
      } else {
        for (let i = 0; i < this.McInitData[it.id - 1].McMonnies.length; i++) {
          if (it.id !== 2) {
            this.McInitData[it.id - 1].McMonnies[i].check = "0";
          }
        }
        this.McInitData[it.id - 1].McMonnies[Number(its.id)].check = 1;
      }
      this.emitFun();
    },
    //  传值
    emitFun() {
      this.McMonniesArr = [];
      this.noCheckAll = [];
      this.McMonniesArr.push({
        age: this.ageId,
        sex: this.sexId,
        val: this.agToal
      });
      for (let i = 0; i < this.McInitData.length; i++) {
        for (let j = 0; j < this.McInitData[i].McMonnies.length; j++) {
          if (this.McInitData[i].McMonnies[j].check === 1) {
            this.McMonniesArr.push({
              type: "EN",
              Pid: this.McInitData[i].id,
              id: this.McInitData[i].McMonnies[j].id,
              val: this.McInitData[i].McMonnies[j].val
            });
          }
        }
      }
      // 存储未选
      if (this.ageId === undefined || this.sexId === undefined) {
        this.noCheckAll.push({
          name: "AGE/Gender",
          id: -1
        });
      }
      // 存储未选中
      for (let i = 0; i < this.McInitData.length; i++) {
        if (!this.isGet3Type) {
          if (this.McInitData[i].id !== 2 && this.McInitData[i].id !== 3) {
            let obj = this.McInitData[i];
            let num = obj.id;
            let isExist = false;
            for (let j = 0; j < this.McMonniesArr.length; j++) {
              let aj = this.McMonniesArr[j];
              let n = aj.Pid;
              if (n === num) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              this.noCheckAll.push(obj);
            }
          }
        } else {
          let obj = this.McInitData[i];
          let num = obj.id;
          let isExist = false;
          for (let j = 0; j < this.McMonniesArr.length; j++) {
            let aj = this.McMonniesArr[j];
            let n = aj.Pid;
            if (n === num) {
              isExist = true;
              break;
            }
          }
          if (!isExist) {
            this.noCheckAll.push(obj);
          }
        }
      }
      // 判断是否选择完全
      this.$emit("emitMcFun", this.McMonniesArr, this.noCheckAll);
    },
    agFunction() {
      if (
        (this.ageId === "0" && this.sexId === "0") ||
        (this.ageId === "0" && this.sexId === "1")
      ) {
        this.agToal = "0";
      } else if (this.sexId === "0" && this.ageId === "1") {
        this.agToal = "1";
      } else if (this.sexId === "1" && this.ageId === "1") {
        this.agToal = "3";
      } else if (this.sexId === "0" && this.ageId === "2") {
        this.agToal = "2";
      } else if (this.sexId === "1" && this.ageId === "2") {
        this.agToal = "6";
      }
      this.emitFun();
    },
    initShow() {
      // 前端传值显示
      if (this.propsChild && this.propsChild.length > 0) {
        let arrAy = this.propsChild;
        this.ageId = arrAy[0].age;
        this.sexId = arrAy[0].sex;
        for (let i = 0; i < arrAy.length; i++) {
          if (arrAy[i].Pid) {
            for (let j = 0; j < this.McInitData.length; j++) {
              if (arrAy[i].Pid === this.McInitData[j].id) {
                this.McInitData[j].McMonnies[arrAy[i].id].check = 1;
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    this.initShow();
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/dryeye/components/questions/EN/McMonnies.vue